module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    staticClass: "chapter",
    attrs: {
      "epub:type": "titlepage",
      "id": "bk"
    }
  }, [_c('p', {
    staticClass: "bkpub1"
  }, [_c('span', {
    staticClass: "page",
    attrs: {
      "aria-label": "iii",
      "id": "piii",
      "role": "doc-pagebreak"
    }
  }), _c('img', {
    attrs: {
      "alt": "",
      "height": "175",
      "src": "images/hayek_crest.jpeg",
      "width": "116"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "sert",
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("The Collected Works of F. A. Hayek")]), _vm._v(" "), _c('p', {
    staticClass: "sers",
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("Volume XIX")]), _vm._v(" "), _c('h1', {
    staticClass: "bk",
    staticStyle: {
      "margin-top": "1em"
    }
  }, [_vm._v("Law, Legislation, and Liberty")]), _vm._v(" "), _c('h1', {
    staticClass: "bk1"
  }, [_vm._v("A New Statement of the Liberal Principles of Justice and Political Economy")]), _vm._v(" "), _c('h1', {
    staticClass: "bk2"
  }, [_c('span', {
    staticClass: "sm"
  }, [_vm._v("VOLUME")]), _vm._v(" "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("1")]), _vm._v(" Rules and Order")]), _vm._v(" "), _c('h1', {
    staticClass: "bk2"
  }, [_c('span', {
    staticClass: "sm"
  }, [_vm._v("VOLUME")]), _vm._v(" "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("2")]), _vm._v(" The Mirage of Social Justice")]), _vm._v(" "), _c('h1', {
    staticClass: "bk2"
  }, [_c('span', {
    staticClass: "sm"
  }, [_vm._v("VOLUME")]), _vm._v(" "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("3")]), _vm._v(" The Political Order of a Free People")]), _vm._v(" "), _c('p', {
    staticClass: "bkau"
  }, [_vm._v("Edited by Jeremy Shearmur")]), _vm._v(" "), _c('p', {
    staticClass: "bkpub"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "75",
      "src": "images/new-press-logo.jpeg",
      "width": "56"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "bkpub1"
  }, [_vm._v("The University of Chicago Press")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-11847dc8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/chi-hayek-vol19-0004.vue
// module id = 63
// module chunks = 0